/** Chevron shown on tappable low-stock / expiring-soon summary stat cards. */
export const InventorySummaryStatCardChevron = () => (
  <svg
    className="pointer-events-none absolute right-1.5 top-1/2 h-4 w-4 shrink-0 -translate-y-1/2 text-gray-400 dark:text-gray-500"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    aria-hidden
  >
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
  </svg>
);
